import React from 'react';
import { personalInfo } from '../data.js';
import { FaLinkedin, FaGithub, FaPhone, FaEnvelope } from 'react-icons/fa';

export default function About({sectionBg}) {

  return (
    <section id="about" className={sectionBg + ' pt-24 h-screen'}>
      <div className="max-w-4xl mx-auto px-6 py-16 text-center">
        {/* Photo and Name */}
        <div className="flex flex-col items-center">
          <img 
            src={personalInfo.photo} 
            alt={personalInfo.name} 
            className="w-40 h-40 rounded-full object-cover border-4 border-gray-300 shadow-lg mb-4"
          />
          <h1 className="text-3xl font-bold mb-2">{personalInfo.name}</h1>
        </div>

        {/* Objective */}
        <p className="text-gray-700 max-w-2xl mx-auto mt-4">{personalInfo.objective}</p>

        {/* Contact Links with Icons */}
        <div className="mt-6 flex flex-col md:flex-row justify-center md:space-x-6 space-y-3 md:space-y-0 text-lg">
          <a href={`mailto:${personalInfo.email}`} className="flex items-center text-blue-600 hover:underline mx-auto md:mx-0">
            <FaEnvelope className="mr-2" /> {personalInfo.email}
          </a>
          <a href={`tel:${personalInfo.phone}`} className="flex items-center text-blue-600 hover:underline mx-auto md:mx-0">
            <FaPhone className="mr-2" /> {personalInfo.phone}
          </a>
          <a href={personalInfo.github} target="_blank" rel="noreferrer" className="flex items-center text-blue-600 hover:underline mx-auto md:mx-0">
            <FaGithub className="mr-2" /> GitHub
          </a>
          <a href={personalInfo.linkedin} target="_blank" rel="noreferrer" className="flex items-center text-blue-600 hover:underline mx-auto md:mx-0">
            <FaLinkedin className="mr-2" /> LinkedIn
          </a>
        </div>
        <div className="mt-16 md:mt-20 flex justify-center">
        <button
          onClick={() => window.dispatchEvent(new Event("openChat"))}
          className="px-4 py-2 rounded-lg bg-gray-800 text-gray-100 hover:bg-gray-700 hover:shadow-md transition flex items-center justify-center gap-1"
        >
          Ask Eliza AI for a quick summary <span className="text-2xl text-gray-100">›</span>
        </button>
      </div>
      </div>
    </section>
  );
}
